import React, { useState } from 'react';

import TextEvents from 'app/components/TextEvents';
import TextInput from 'app/components/TextInput';
import { Grid } from '@material-ui/core';
import { Select, Divider, Checkbox, Button, DatePicker, Spin, Alert, message } from 'antd';
import ManagementReportContainer from 'app/containers/ManagementReportContainer';

import { fetchManagementReport } from 'app/actions/ManagementReportActions';
import { useDispatch, useSelector } from 'react-redux';
import {getManagementReport, getIsLoadingManagementReport } from 'app/reducers';


const { Option } = Select;
const SelectItem = (name = [], value) => {
    if(name == null || name == undefined) name = [];
    let x = [...new Set(name.map(i => i[value]))];
    return typeof x !== 'undefined' && x !== null ? x.map((c, i) => <Option key={i}>{c}</Option>) : (x === null ? <Option key={'cargando'}>No existen valores..</Option> : <Option disabled key={'cargando'}>Cargando valores..</Option>);

}

export default function ManagementReportForm(props) {
    const classes =props.classes;
    const [cp, setCP] = useState('');
    const dispatch = useDispatch();
    const pdfData = useSelector(getManagementReport);
    const isLoading=useSelector(getIsLoadingManagementReport);

    const [front, setFront] = useState('');
    const [company, setCompany] = useState('');
    const [homologate, setHomologate]= useState(false)
    const [creationDateI, setCreationDateI] = useState('');
    const [creationDateF, setCreationDateF] = useState('');
    const [PDFData, setPdfData]= useState();
    
    const data = {
        idCommunicationProgram: cp,
        idFront: front,
        StartDate: creationDateI,
        EndDate: creationDateF,
        Company: company,
        applyHomologusProcedure: homologate
    }

    const  handleChange = (i, key) => {
        if(key==='communicationProgramName')setCP(i.idCommunicationProgram)
        if(key==='frontName')setFront(i.idFront)
        if(key==='clientName')setCompany(i.idClient)

        if (i.idClient <= 0) setHomologate(false);
    }
    const handleChangeCheck = (value) => {
        if (company <= 0)setHomologate(false);
        else setHomologate(value);
    }
    const getPreview = () => new Promise((resolve, reject) => {
        resolve(dispatch(fetchManagementReport(data, data.idCommunicationProgram)));
    });

    const onSubmit = () => {
        getPreview().then(()=>'', ()=> message.error('Ocurrió un error intente mas tarde.'));        
    }
    if(!isLoading && Object.keys(pdfData)>0) setPdfData(pdfData.pdf)
    return (
        <div>
            <ManagementReportContainer >
                {((params)=>{
                    return <div>
                    <Grid container direction='row'>
                                <Grid item xs={12}>
                                    <Divider orientation="left" style={props.styles.dividerDefault}>Parámetros de generación</Divider>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextInput
                                        text='Programa de comunicación'
                                        color='darker'
                                        size='label'
                                        showSearch
                                        weight='medium'
                                        placeholder='Selecciona programa de comunicación'
                                        style={props.styles.inputSelect}
                                        onChange={(v, i)=>handleChange(params.managementFilters[0].communicationProgram[v], 'communicationProgramName')}
                                    >
                                        {params.managementFilters.length>0 ? SelectItem(params.managementFilters[0].communicationProgram, 'communicationProgramName'):''}
                                    </TextInput>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextInput
                                        text='Frente'
                                        color='darker'
                                        size='label'
                                        showSearch
                                        weight='medium'
                                        placeholder='Selecciona frente'
                                        style={props.styles.inputSelect}
                                        onChange={(v, i)=>handleChange(params.managementFilters[0].front[v], 'frontName')}
                                    >
                                        {params.managementFilters.length>0 ? SelectItem(params.managementFilters[0].front, 'frontName'):''}
                                    </TextInput>
                                </Grid>
                            </Grid>
                            <Grid container direction='row'>
                                <Grid item xs={12} md={6}>
                                    <TextEvents
                                        text='Rango a considerar'
                                        color="darker"
                                        size='label'
                                        weight="medium"
                                    />
                                    <TextEvents
                                        text='Desde:'
                                        color="gray"
                                        size='tiny'
                                        weight="light"
                                        styleDisplay='initial'
                                        styleMargin='2px'
                                    />
                                    <DatePicker
                                        style={{width:'42%'}}
                                        format={'DD/MM/YYYY'}
                                        onChange={(date, dateString) => {
                                            setCreationDateI(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                                        }}

                                    /> <TextEvents
                                        text='Hasta:'
                                        color="gray"
                                        size='tiny'
                                        weight="light"
                                        styleDisplay='initial'
                                        styleMargin='2px'
                                    />
                                    <DatePicker
                                        style={{width:'43.8%'}}
                                        format={'DD/MM/YYYY'}
                                        onChange={(date, dateString) => {
                                            setCreationDateF(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextInput
                                        text='Compañía'
                                        color='darker'
                                        size='label'
                                        showSearch
                                        weight='medium'
                                        placeholder='Selecciona compañía'
                                        style={props.styles.inputSelect}
                                        onChange={(v, i)=>handleChange(params.managementFilters[0].company[v], 'clientName')}
                                        >
                                        {params.managementFilters.length>0 ? SelectItem(params.managementFilters[0].company, 'clientName'):''}
                                    </TextInput>
                                    <Checkbox checked={homologate} onChange={(e)=> handleChangeCheck(e.target.checked)}>Considerar procedimientos homólogos (Si aplican o existen)</Checkbox>
                                </Grid>
                            </Grid>
                            <Grid container direction='row'>
                                <Grid item xs={12}>
                                    <div className={classes.container} style={props.styles.baseVerticalMargin}>
                                        <Button
                                            className={classes.button}
                                            variant="contained"
                                            type="primary"
                                            onClick={onSubmit}
                                            disabled={ front === ''|| cp==='' || creationDateI==='' || creationDateF ==='' || company ===''|| homologate===''}
                                            >
                                            Generar
                                        </Button>
                                    </div>
                                </Grid>
                            </Grid>
                            {!isLoading && Object.keys(pdfData).length>0 ? <Grid container direction='row'>
                                <Grid item xs={12}>
                                    <div style={{height: '500px', display: 'flex'}}>
                                        <embed src={pdfData.pdf.urlFile} width="100%" height="100%"  type="application/pdf"/>
                                    </div>
                                </Grid>
                            </Grid>:<div>
                                <Spin spinning={isLoading}>
                                    <Alert
                                        message="Información PDF"
                                        description="Una vez generado el reporte, podrá visualizarlo en esta sección."
                                        type="info"
                                        showIcon
                                    />
                                    </Spin>
                                </div>}
                    </div>
                })}
        </ManagementReportContainer>
        </div>
    )
}